import React, { useEffect, useState } from "react";
import "./Shorts.css";
import db from "../../firebase"; // 👈 Firestore instance
import { doc, getDoc, updateDoc } from "firebase/firestore";

// 🔹 Shimmer UI for shorts
const ShortsShimmer = () => (
  <div className="shorts-wrapper">
    {[1, 2, 3].map((i) => (
      <div className="short-card shimmer-card" key={i}>
        <div className="shimmer-thumbnail shimmer-anim" />
        <div className="shimmer-input shimmer-anim" />
      </div>
    ))}
  </div>
);

const Shorts = ({ isLoggedIn }) => {
  const [shortsLinks, setShortsLinks] = useState([]);
  const [editedLinks, setEditedLinks] = useState([]);
  const [loading, setLoading] = useState(true); // 🔹 for shimmer
  const shortsDocRef = doc(db, "shorts", "shortsList");

  // Fetch shorts from Firebase
  useEffect(() => {
    console.log(isLoggedIn);
    const fetchShorts = async () => {
      try {
        setLoading(true);
        const docSnap = await getDoc(shortsDocRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setShortsLinks(data.links || []);
          setEditedLinks(data.links || []);
        }
      } catch (err) {
        console.error("Error fetching shorts:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchShorts();
  }, []);

  // Update local state
  const handleInputChange = (index, value) => {
    const newLinks = [...editedLinks];
    newLinks[index] = value;
    setEditedLinks(newLinks);
  };

  // Apply updates to Firebase
  const handleApply = async () => {
    try {
      await updateDoc(shortsDocRef, { links: editedLinks });
      setShortsLinks(editedLinks);
      alert("Shorts updated successfully ✅");
    } catch (err) {
      console.error("Error updating shorts:", err);
    }
  };

  return (
    <div className="shorts-container">
      <h2 className="shorts-heading" data-aos="zoom-in"> YouTube Shorts</h2>

      {/* 🔹 Show Shimmer while loading */}
      {loading ? (
        <ShortsShimmer />
      ) : (
        <div className="shorts-wrapper">
          {shortsLinks.map((link, index) => {
            const videoId = link.split("/shorts/")[1];
            return (
              <div key={index} className="short-card" data-aos="zoom-in">
                <iframe
                  width="280"
                  height="500"
                  src={`https://www.youtube.com/embed/${videoId}`}
                  title={`Short ${index + 1}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
                {isLoggedIn && (
                  <input
                    type="text"
                    value={editedLinks[index] || ""}
                    onChange={(e) => handleInputChange(index, e.target.value)}
                    placeholder="Update video link"
                    className="short-link-input"
                  />
                )}
              </div>
            );
          })}

          {/* More Shorts link */}
          {/* <div className="more-shorts">
            <a
              href="https://www.youtube.com/@AlMuntazarTV/shorts"
              target="_blank"
              rel="noopener noreferrer"
              className="short-card text-center"
            >
              👉 Want to see More Shorts
            </a>
          </div> */}
        </div>
      )}

      {/* Apply button (only for logged in) */}
      {!loading && isLoggedIn && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <button onClick={handleApply}>Apply Changes</button>
        </div>
      )}
    </div>
  );
};

export default Shorts;
